import PaymentCheckout from './PaymentCheckout';

export { PaymentCheckout };
